import { render } from "./TerminalSuape.vue?vue&type=template&id=1928c76f"
import script from "./TerminalSuape.vue?vue&type=script&lang=js"
export * from "./TerminalSuape.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__